import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ProductService {

  mangentoUrl = environment.apiURL
  constructor(private http: HttpClient) { }

  notInteretedSuggest(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/notInteretedSuggest`, data);
  }

  notInterestProduct(data):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/notInterestProduct`, data);
  }
  getProducts(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/getAllProducts`, data);
  }

  suggestBannerProducts(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/suggestBannerProducts`, data);
  }
  recommendationProductsSlider(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/recommendationProductsSlider`, data);
  }
  productBoxes():Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/productBoxes`, {});
  }

  storeSuggestBanner():Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/storeSuggestBanner`, {});
  }

  getRspFilterRange(data):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/rspMinMaxFilter`, data);
  }

  getProductDetail(productSku):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/getProductDetail`, {'sku':productSku});
  }

  addToCart(obj):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/addToCart`, obj);
  }
  biRecommend(obj):Observable<any> {
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/biRecommend`, obj);
  }
  
  qytUpdate(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V2/updateQty`, obj);
  }

  qytUpdateV3(obj):Observable<any>{
    return this.http.post<any>(`${this.mangentoUrl}rest/V3/updateMiniCartItem`, obj);
  }
}
